'use client';

import type { BaseComponentProps, ContentfulPatternElementType } from '@bedrock/core/contentful';
import AnnouncementBar from '@bedrock/ui-patterns/announcement-bar';
import './announcement-bar.css';

export default function AnnouncementBarWrapper(
  props: Readonly<BaseComponentProps<ContentfulPatternElementType>>,
) {
  return (
    <div className="announcement-bar-gradient absolute z-50 hidden w-full 2xl:block">
      <AnnouncementBar {...props} />
    </div>
  );
}
